var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeConsulta = function SvgIconeConsulta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#C5D4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_31261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 12,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_31261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2162 13.5195C14.2162 13.5195 11.6571 13.3674 10.6685 14.389C7.79226 17.361 4.32448 23.9925 2.15278 27.8653C1.50529 29.02 0.788553 29.6318 0.468236 30.2013C-0.0208006 31.0707 -0.0208257 32.3206 0.739773 32.5379C1.01164 32.6156 1.55504 31.8858 1.66367 31.6141C1.82674 31.9402 2.0441 32.2662 2.3158 32.1032C2.47886 32.0054 2.15278 31.9402 2.91354 30.5273C4.31288 27.9286 11.5536 19.66 11.5536 19.66L12.423 25.0396L19.3242 25.0396L20.085 19.2789C24.4322 19.4419 28.9253 17.9116 30.8444 13.9535C31.7138 12.1603 32.2572 11.8886 32.4202 11.2909C32.7819 9.96462 32.3115 9.05113 31.8225 9.0086C31.4435 8.97565 31.2247 9.8237 31.0617 10.0954C30.8987 9.98672 30.6813 9.44332 30.301 9.71502C30.0755 9.87607 30.6813 9.8237 29.6489 12.432C28.5734 15.149 24.3381 17.5648 19.8133 14.389C18.8154 13.6885 17.3679 13.5195 17.3679 13.5195L14.2162 13.5195Z",
    fill: "#84AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5312 25.8509C19.5312 25.8509 16.1175 26.1863 12.5987 25.8509C11.1795 21.4449 12.4741 15.2735 14.4894 14C14.4894 14 15.3284 14.7393 16.17 14.7267C16.9845 14.7145 17.693 14.1677 17.693 14.1677C20.2994 16.0002 20.3519 22.9319 19.5312 25.8509Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0176 14.3523C23.6181 15.3237 26.2194 16.2955 29.5186 12.0861L31.3119 13.2816C30.0447 18.4268 25.5503 19.6055 22.9061 20.2989C21.8083 20.5868 21.0294 20.7911 20.9329 21.1609C20.6122 22.3904 24.4308 39.5402 24.4308 39.5402H18.3447L17.0406 14.7611L17.584 13.5113C18.7661 13.5113 19.8917 13.9318 21.0176 14.3523ZM7.29354 39.2685H15.1386C15.27 36.522 15.7364 14.7068 15.7364 14.7068L14.3235 13.5113C14.3235 13.5113 11.7612 13.3245 10.4111 14.4351C7.04197 17.2064 3.1637 23.5518 1.04443 28.8228L3.54408 30.0727C4.68454 28.8631 6.98562 25.6442 8.50977 23.5122C9.38213 22.2919 9.99997 21.4277 9.99997 21.5C9.99997 25.443 8.65086 32.3305 7.65878 37.3952C7.52974 38.054 7.40675 38.6819 7.29354 39.2685Z",
    fill: "#ECF0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4999 10.5C19.3815 11.2927 19.0483 11.881 18.5203 12.3034C18.0856 12.6512 17.5338 12.6078 17.409 12.8686C17.2842 13.1294 17.5994 13.4989 17.5994 13.4989C17.5994 13.4989 16.9661 14.314 16.0423 14.314C15.1185 14.314 14.2491 13.4989 14.2491 13.4989C14.6493 12.7382 14.6493 11.1528 14.6493 11.1528C14.526 11.0017 14.4303 10.8822 14.4303 10.8822C14.4303 10.8822 14.0948 10.4518 13.9741 10.0202C13.8535 9.58858 13.936 9.06589 13.9964 8.79198C14.069 8.46327 14.2196 8.13333 14.4303 7.86207C14.6437 7.58729 14.9094 7.33077 15.4396 7.10315C16.4932 6.65083 17.3184 6.97109 17.5994 7.10315C17.8805 7.23522 18.1524 7.43044 18.4131 7.72025C18.6739 8.01006 19.6722 9.34721 19.4999 10.5Z",
    fill: "#84AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7311 7.86431C17.4696 7.95437 17.8667 8.64909 17.5952 9.11106C17.3237 9.57303 16.4412 10.3515 16.4412 10.3515C16.4412 10.3515 16.1162 12.143 15.7131 12.6524C14.9409 13.6284 14.1236 13.3148 13.5365 13.6284C13.0804 13.8719 11.9056 14.8985 11.0644 15.0599C10.2232 15.2214 9.01481 14.8985 8.6031 14.0393C8.19139 13.1801 8.21166 12.3715 8.94125 11.5509C9.67083 10.7303 10.5842 11.3008 10.9733 11.017C11.3625 10.7333 11.2861 9.93491 11.9402 9.3522C12.6335 8.73442 13.5365 8.56492 13.5365 8.56492C13.5365 8.56492 13.8601 7.47111 14.8177 6.92616C15.7754 6.38122 16.7977 6.45383 17.5158 6.71521C18.5261 7.08297 18.7393 8.06689 18.6324 8.07813C18.5254 8.08937 17.9926 7.77425 17.7311 7.86431Z",
    fill: "#003A79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 14V16.5833C13.8333 17.8167 14.7458 18.875 15.9749 19.0458C15.9999 20 15.6025 23.1667 18.6249 23.1667C18.9806 23.1667 19.3328 23.0966 19.6614 22.9605C19.9899 22.8244 20.2885 22.6249 20.54 22.3734C20.7915 22.1219 20.991 21.8234 21.1271 21.4948C21.2632 21.1662 21.3333 20.814 21.3333 20.4583V19.9208C21.8166 19.7458 22.1666 19.2875 22.1666 18.75C22.1666 18.4185 22.0349 18.1005 21.8005 17.8661C21.566 17.6317 21.2481 17.5 20.9166 17.5C20.5851 17.5 20.2671 17.6317 20.0327 17.8661C19.7983 18.1005 19.6666 18.4185 19.6666 18.75C19.6666 19.2875 20.0166 19.75 20.4999 19.9208V20.4208C20.4999 21.4625 19.6666 22.2958 18.6249 22.2958C16.5941 22.2958 16.8416 19.8192 16.8416 19.0417C17.9999 18.7917 18.8333 17.75 18.8333 16.5833V13.5C18.8333 12.9446 18.5553 12.6667 17.9999 12.6667C16.9999 12.6667 17.3053 13.5 17.5833 13.5H17.9999V16.5833C17.9999 17.0254 17.8243 17.4493 17.5118 17.7618C17.1992 18.0744 16.7753 18.25 16.3333 18.25C15.8912 18.25 15.4673 18.0744 15.1547 17.7618C14.8422 17.4493 14.6666 17.0254 14.6666 16.5833V13.6667L14.4999 13.5L13.8333 14Z",
    fill: "#0069D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31261",
    x: 0.222222,
    y: 0.111111,
    width: 35.5556,
    height: 35.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.286275 0 0 0 0 0.560784 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31261",
    x: 0.0444336,
    y: 11.0861,
    width: 32.2673,
    height: 29.4541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.666667 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31261",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeConsulta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-consulta.0d9333ea.svg";
export { ForwardRef as ReactComponent };